<template>
  <div :class="{'sidebar':true, 'open':sidebarOpen}">
    <vue-scroll class="scroller">
      <div class="widget close-filter-box">
        <button @click="sidebarClose()">
          <i class="mdi mdi-close close-icon"></i> Cerrar
        </button>
      </div>
      <div class="stiky title-card card-form card-base card-outline card-shadow--small">
        <div class="invoice_title">
          <i class="mdi mdi-file-document"></i> # 1
          <el-button type="primary" class="btn" size="small">
            <i class="mdi mdi-printer"></i> Imprimir
          </el-button>
          <el-button type="success" class="btn" size="small">
            <i class="mdi mdi-content-save-outline"></i> Guardar
          </el-button>
        </div>
      </div>

      <div class="widget">
        <div class="title" :class="selected_person ? 'selected-person' : ''">
          <h4 class="m-0 cart-product-details-parent" v-if="selected_person">
            <div class="cart-product-details-child">
              <i class="mdi mdi-account-check"></i> {{ personData.name }}
              <br> 
              <small><i class="mdi mdi-email"></i> {{ personData.email }}</small> 
              <small> <i class="mdi mdi-phone"></i> {{ personData.phone }}</small>
            </div> 
            <a href="#" class="cart-product-details-child" @click="removePerson"><i class="mdi mdi-close"></i></a>
          </h4>
          <el-autocomplete v-else 
            placeholder="Buscar Cliente..." 
            v-model="person_search.nombre" 
            :fetch-suggestions="querySearchAsync" 
            @select="handleSelect" 
            clearable>
            <i slot="prefix" class="el-input__icon el-icon-s-custom"></i>
            <template slot-scope="{ item }">
                <div class="" style="line-height: 1;padding: 8px 0 8px">
                  <i class="mdi mdi-account"></i> {{ item.nombre }}<br>
                  <small>
                    <i class="mdi mdi-clipboard-account"></i> {{ item.documento }}
                  </small>
                </div>
              </template>
            <template slot="append">
							<el-tooltip class="item" effect="dark" content="Registrar Nuevo" placement="top">
								<el-popover placement="bottom-start" trigger="click">
									<div class="content-data">
										<div
											class="page-header header-accent-gradient card-base card-shadow--small header-client"
										>
											<h1>
												<i class="mdi mdi-account-multiple-plus"></i> Registro de Cliente
												<el-tooltip class="item" effect="dark" content="Guardar Cliente" placement="top">
													<el-button
														icon="mdi mdi-content-save-outline"
														circle
														class="btn-person-save"
                            @click="savePerson"
													></el-button>
												</el-tooltip>
											</h1>
										</div>
										<div class="form-box">
											<el-form ref="form" :model="personData" label-width="150px">
												<el-form-item label="Cédula / Nit">
													<el-input placeholder="Cédula / Nit" v-model="personData.nit"></el-input>
												</el-form-item>
												<el-form-item label="Nombre">
													<el-input placeholder="Nombre" v-model="personData.name"></el-input>
												</el-form-item>
												<el-form-item label="E-mail">
													<el-input placeholder="E-mail" v-model="personData.email"></el-input>
												</el-form-item>
												<el-form-item label="Teléfono">
													<el-input placeholder="Teléfono" v-model="personData.phone"></el-input>
												</el-form-item>
												<el-form-item label="Dirección">
													<el-input placeholder="Dirección" v-model="personData.address"></el-input>
												</el-form-item>
												<el-form-item label="Ciudad">
													<el-input placeholder="Ciudad" v-model="personData.city"></el-input>
												</el-form-item>
												<el-form-item label="Cumpleaños">
													<el-date-picker
														v-model="personData.birthday"
														type="date"
														placeholder="aaaa-mm-dd"
                            value-format="yyyy-MM-dd"
													></el-date-picker>
												</el-form-item>
											</el-form>
										</div>
									</div>
									<el-button slot="reference" icon="mdi mdi-account-edit" style="font-size: 25px;"></el-button>
								</el-popover>
							</el-tooltip>
            </template>
          </el-autocomplete>
        </div>
        <div class="content">
          <div class="content-data">
            <div class="page-header header-accent-gradient card-base card-shadow--small">
              <h1>
                <i class="mdi mdi-cash-multiple"></i> Forma de pago
              </h1>
            </div>
            <div class="form-box">
              <el-form ref="form" :model="payment_method" label-width="150px">
                <el-form-item label="Efectivo">
                  <el-input placeholder="$ Efectivo" v-model="userdata.id"></el-input>
                </el-form-item>
                <el-form-item label="TC/TD">
                  <el-row>
                    <el-col :md="12" :lg="12" :xl="12">
                      <el-input placeholder="$ TC/TD" v-model="userdata.id"></el-input>
                    </el-col>
                    <el-col :md="12" :lg="12" :xl="12">
                      <el-input placeholder="Código de confirmación" v-model="userdata.id"></el-input>
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item label="NC">
                  <el-input placeholder="$ NC" v-model="userdata.id"></el-input>
                </el-form-item>
                <el-form-item label="Bono">
                  <el-input placeholder="$ Bono" v-model="userdata.id"></el-input>
                </el-form-item>
                <el-form-item label="Empleado">
                  <el-input placeholder="$ Empleado" v-model="userdata.id"></el-input>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </vue-scroll>
  </div>
</template>

<script>
import { search as searchClient, save as savePerson } from '@/api/person'
export default {
  name: "Pos",
  props: ["sidebarOpen"],
  data() {
    return {
      userdata: {
        id: null,
        date: null
      },
      payment_method: {},
      selected_person: false,
      person_search: {},
      personData: {
        id: null,
        nit: null,
        name: null,
        email: null,
        phone: null,
        address: null,
        city: null,
        birthday: null
      }
    };
  },
  computed: {},
  methods: {
    sidebarClose() {
      this.$emit("close");
    },
    savePerson(){
      var data = {
        documento:  this.personData.nit,
        nombre:     this.personData.name,
        email:      this.personData.email,
        telefono:   this.personData.phone,
        direccion:  this.personData.address,
        ciudad:     this.personData.city,
        nacimiento: this.personData.birthday,
      }
      savePerson(data).then(({data}) => {
        this.$message({
          type: "success",
          message: "Registro de clinete exitoso!"
        });
        this.selected_person = true
      }).catch(error => {
        this.$message.error('Error registrar cliente.')
        console.log(error)
      })
    },
    removePerson(){
      this.selected_person = false
      this.personData= {
        id: null,
        nit: null,
        name: null,
        email: null,
        phone: null,
        address: null,
        city: null,
        birthday: null
      }
    },
    querySearchAsync(queryString, cb) {
      if (queryString.length > 3) {
        searchClient(queryString, 'cliente').then(({data}) => {
            cb(data.data);
        }).catch( error => { console.log(error) })
      }
    },
    handleSelect(item) {
      this.personData = {
        id: item.id,
        nit: item.documento,
        name: item.nombre,
        email: item.email,
        phone: item.telefono,
        address: item.direccion,
        city: item.ciudad,
        birthday: item.nacimiento,
      }
      this.selected_person = true
    }
  },
  created() {},
  mounted() {}
};
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/_variables";
@import "../../../assets/scss/app/personPay";
</style>